export default "__VITE_ASSET__C7oLU9un__"